const _ = require('lodash');

const OrderStatus = {
  toreview: '资料待审核', pass: '资料审核通过', declined: '资料审核不通过', added: '已增员', attrition: '已减员', cancel: '已过期'
}

const PayStatus = {
  paid: '已支付', pending: '待支付', audit: '转账待审核', fail: '转账审核失败',  expired: '已失效', refund: '已退费'
};

const PayType = {
  wechat: '微信支付', bank: '银行卡转账'
}

const PaymentWay = {
  normal: '代缴', payback : '补缴'
}

// 区分服务状态
const ServcieOrderOnlyState = {
  processing: '处理中', mod: '资料待修改', completed: '已完成', cancelled: '已取消', refund: '已退费', reviewed: '已评价'
};

// !已过期!
const PaymentItem = {
  gongjijin: '公积金', shebao : '社保', all: '五险一金'
}

const PaymentTerm = {
  month: '按月', halfyear : '按半年'
}

const CensusType = {
  city: '城市户口', country : '农村户口'
}

// 新版本的
const PaymentItemEx = {
  shebao: '社保', gongjijin: '公积金', tax: '个税', salary: '代发工资', ztax: '零申报'
}

const PaymentPaybackItemEx = {
  shebao: '社保', gongjijin: '公积金'
}

const TaxWay = {
  salary: '工资报税', service: '劳务报税'
}

const LocationsRandom = [ "丰台", "通州", "昌平", "石景山"];
const LocationsNormal = [ "丰台", "通州", "昌平", "石景山", "海淀", "朝阳", "大兴", "朝阳二",  '海淀三'];
const LocationsGongjijin = [ "丰台", "通州", "石景山", "昌平", "海淀", "朝阳", "大兴", "朝阳二",  '海淀三'];;

function getLocation(gongjijin = false) {
  return !gongjijin ? LocationsNormal : LocationsGongjijin
}

// 返回名字跟值都是汉字的，方便结构，也是兼容之前的数据结构
function getLocationList(gongjijin = false) {
  return getLocation(gongjijin).map( x => {
    return {name: x, value: x}
  })
}

function toList (obj) {
  return _.map(_.keys(obj), n => { return { name: obj[n], value: n } })
}

const PaymentItemExDesc = _.invert(PaymentItemEx)
const PaymentItemExList = toList(PaymentItemEx)
const PaymentPaybackItemExList = toList(PaymentPaybackItemEx)


// 变成 '城市户口' -> city 这种值
const CensusTypeDesc = _.invert(CensusType)

const CensusTypeList = toList(CensusType)

const PaymentWayList = toList(PaymentWay)

const PaymentTermList = toList(PaymentTerm)

const TaxWayList = toList(TaxWay)



const PaymentItemRefs = {
  salary: {
    items: ['shebao', 'gongjijin', 'tax'],
    conflictItems:['ztax'],
    tips: '代发工资需同时缴纳社保和个税'
  },
  shebao: {
    items: ['gongjijin', 'tax', 'salary'],
    conflictItems:[],
    tips: '缴纳社保必须同时缴纳公积金'
  },
  gongjijin: {
    items: ['shebao', 'tax', 'salary'],
    conflictItems:[],
  },
  tax: {
    items: [],
    conflictItems:['ztax'],
    //selectedTips: '摇号专用，服务费200/月'
  },
  ztax: {
    items: ['shebao', 'gongjijin'],
    //selectedTips: '零申报即个税金额申报为0元，目的是顺应将来退休等社保政策变动。特别提示：个税零申报不能用于北京小客车摇号。',
    conflictItems: ['tax', 'salary']
  }
}


module.exports = {
  OrderStatus,
  PaymentWay,
  PaymentItem,
  PaymentTerm,
  PaymentTermList,
  CensusType,
  PayStatus,
  PayType,
  PaymentItemEx,

  ServcieOrderOnlyState,

  PaymentItemExDesc,
  CensusTypeDesc,
  CensusTypeList,
  PaymentWayList,
  PaymentItemExList,
  PaymentItemRefs,
  PaymentPaybackItemExList,

  TaxWay,
  TaxWayList,

  LocationsNormal,
  LocationsRandom,
  LocationsGongjijin,
  getLocationList
}



// WEBPACK FOOTER //
// ./src/pages/util/state_desc.js